import React, { Component } from 'react';
import NavBar from './NavBar.js';
import Footer from './Footer.js';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import EmpresaDisplay from './EmpresaDisplay.js';
import { properties } from './properties.js';
import { withTranslation } from 'react-i18next';
import i18n from './I18N/I18n.js'; 
import { loadWeb3, logout, apiPublicRequest, apiSecuredRequest, isUserOrWallet, setBearer, isRootWallet, cargarIdiomaPreferido} from './functions.js';
import './css/listaEmpresas.css'

class ListaEmpresas extends Component {

    async componentDidMount() {
      await cargarIdiomaPreferido(this.cambiarIdioma);
        // 1. Carga de Lista de empresas
        await this.checkIfWeb3UserOrLoginUser()
  
      }

      cambiarIdioma = (idioma) => {
          const { i18n } = this.props;
          i18n.changeLanguage(idioma); 
          this.forceUpdate(); 
          Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
        };

      logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
      }

      async checkIfWeb3UserOrLoginUser() { 
        localStorage.removeItem('empresa');
        const email = Cookies.get("email");
        this.setState({ email: email });
        let bearerVar = Cookies.get("id");
        this.setState({ bearer: bearerVar });
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
        let account = await isUserOrWallet(email, bearerVar);
        const bearerToken = await setBearer(email, bearerVar, account);
        this.setState({bearer: bearerToken})
        var empresasList;
        if(account != 0) {
          
          const updateData = JSON.stringify({
            "walletDir": account
            
          });
          
          empresasList = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/empresas/getStandardDataEmpresasbyWallet`, updateData, bearerVar);
      } else {
        

        empresasList = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/empresas/getStandardDataEmpresas`, "", bearerVar);
                      
       
      
      }

      const sortedBrands = [...empresasList.data].sort((a, b) => a.name.localeCompare(b.name));
        
      


        this.setState({ empresas: sortedBrands })

      }

        constructor(props) {
            super(props)
            this.state = {
              empresas: null,
              account: null, 
              email: null, 
              userRol: null,
              bearer: null
            }
          }

          render() {

            if (this.state.empresas != null) {
              return (
                <>
                 <NavBar mail = {this.state.email} bearer = {this.state.bearer} logout = {this.logout} cambiarIdioma={this.cambiarIdioma}/>

                      <table className="cewyBrandsTable">
                        <div className="cewyBrandsContainer">
                          <p className="cewyTitleBrands"> {i18n.t('AllBrands')}</p>
                          
                          <tbody>
                            <EmpresaDisplay items={this.state.empresas} />
                          </tbody>
                        </div>
                      </table>
                  <Footer />
                </>
              );
        
            } else {
        
              <h1>Loading</h1>
            }
          }  
    

 } export default  withTranslation()(ListaEmpresas);